import { isProd } from '~constants'

export const gaDLPush = (params: any) => {
  if (typeof window !== 'undefined' && isProd) {
    window.dataLayer.push(params)
  } else {
    console.debug('/// gaDLPush params: ', params)
  }
}
